import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Track the user downloading items',
  name: 'downloaded_items',
  params: [
    {
      description: 'Total alt resolution ids',
      name: 'altResolutionIds',
      required: false,
      type: 'array',
      values: ['string'],
    },
    {
      description: 'Total board ids',
      name: 'boardIds',
      required: false,
      type: 'array',
      values: ['string'],
    },
    {
      description: 'Total clip ids',
      name: 'clipIds',
      required: false,
      type: 'array',
      values: ['string'],
    },
  ],
};

export default META;
